import { useTranslation } from 'react-i18next';
import logoLightRaw from '@/assets/brand/logo-light.svg?raw';
import logoDarkRaw from '@/assets/brand/logo-dark.svg?raw';

interface LogoImageProps {
  /** `light` = logo blanco; `dark` = logo burdeos (#4F1213) */
  variant?: 'light' | 'dark';
  /** `nav` barra superior; `footer` pie de página (más grande) */
  size?: 'nav' | 'footer';
  className?: string;
}

function prepareSvg(raw: string): string {
  return raw
    .replace(/\swidth="[^"]*"/, '')
    .replace(/\sheight="[^"]*"/, '')
    .replace('<svg ', '<svg class="block h-full w-auto max-w-full" ');
}

const SIZE_CLASS = {
  nav: 'h-11 w-[min(100%,11rem)] sm:h-12 sm:w-[min(100%,12rem)] md:h-14 md:w-[min(100%,14rem)]',
  footer: 'h-14 w-[min(100%,14rem)] sm:h-16 sm:w-[min(100%,16rem)] md:h-[min(5.5rem,18vw)] md:w-[min(100%,18rem)]',
} as const;

export default function LogoImage({
  variant = 'dark',
  size = 'nav',
  className = '',
}: LogoImageProps) {
  const { t } = useTranslation();
  const raw = variant === 'light' ? logoLightRaw : logoDarkRaw;
  const svgHtml = prepareSvg(raw);

  return (
    <a
      href="#inicio"
      className={`inline-flex shrink-0 items-center ${className}`}
      aria-label={`L&J PREMIUM MEATS LLC — ${t('nav_home')}`}
    >
      <div
        className={`logo-svg ${SIZE_CLASS[size]}`}
        role="img"
        aria-label="L&J PREMIUM MEATS LLC"
        dangerouslySetInnerHTML={{ __html: svgHtml }}
      />
    </a>
  );
}
